import processEnv from "../processEnv";

const createShareGroopOrder = () => {
  const bodyP = {
    amount: 49745,
    trackId: "OVBDPH",
    ux: "single",
    items: [
      {
        trackId: "YenFlightTicket",
        name: "Product A",
        description: "Description A",
        amount: 49745,
        quantity: 1,
      },
    ],
  };
  console.warn("BODY P: ", bodyP);
  return fetch(`https://api.sandbox.sharegroop.com/v1/orders`, {
    method: "POST",
    referrerPolicy: "no-referrer",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
      "Content-Type": "application/json",
      "Accept-Encoding": "gzip",
      Accept: "application/json",
      "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",

      Authorization: "sk_test_e1ed6973-3ed9-467e-af49-9d6330cd49aa",
    },
    body: JSON.stringify(bodyP),
  });
};

export default createShareGroopOrder;
